import React, { useEffect, useRef, useState } from "react";
import { Calendar } from "primereact/calendar";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { CalendarIcon, ChevronLeft, ChevronRight, Pencil, X, Check } from "lucide-react";
import "./SlotManagement.css";
import axios from "axios";
import { Toast } from "primereact/toast";
import { getDisabledCourts, unBlockCourts } from "./SlotHooks";
import { ProgressSpinner } from "primereact/progressspinner";
import { FaCheck } from "react-icons/fa";
import { GrClose } from "react-icons/gr";
import { encryptedAuth } from "../../Services/EncryptData";
import { postBlockedcourt } from "../../Services/BackendUrl";

const courts = [1, 2, 3, 4, 5, 6, 7];

const formatDate = (dateObj) =>
  dateObj.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

const shortDate = (dateObj) =>
  dateObj.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short", 	
  });

const SlotManagement = () => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [startIndex, setStartIndex] = useState(0);
  const [editingCourt, setEditingCourt] = useState(null);
  const [availability] = useState({});
  const [pendingDates, setPendingDates] = useState({});
  const [disabledDate, setDisableDate] = useState({});
  const toast = useRef(null);
  const [loading, setLoading] = useState(false);
const [loadingCell, setLoadingCell] = useState({ court: null, date: null });
const [appliedCourts, setAppliedCourts] = useState({});


  useEffect(() => {
    getDisabledCourts().then((res) => {
      if (res.status === 200) {
        setDisableDate(res.data.data);
      }
    });
  }, []);


  const convertToYMD = (dateStr) => {
    const dateObj = new Date(dateStr);
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const day = String(dateObj.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const generateDates = () => {
    const newDates = [];
    const baseDate = new Date(selectedDate);
    baseDate.setDate(baseDate.getDate() + startIndex);
    for (let i = 0; i < 7; i++) {
      const d = new Date(baseDate);
      d.setDate(baseDate.getDate() + i);
      newDates.push(d);
    }
    return newDates;
  };

  const fullDates = generateDates();
  const formattedDates = fullDates.map((d) => shortDate(d));
  const fullDateStrings = fullDates.map((d) => formatDate(d));

  const isAvailable = (courtIndex, fullDateStr) => {
    const courtKey = `${courtIndex + 1}`;
    return !disabledDate[courtKey]?.includes(convertToYMD(fullDateStr));
  };

const toggleAvailability = (court, fullDateStr) => {
  const unavailableDates = availability[court] || [];

  const updated = convertToYMD(
    unavailableDates.includes(fullDateStr)
      ? unavailableDates.filter((d) => d !== fullDateStr)
      : [...unavailableDates, fullDateStr]
  );

  setLoadingCell({ court, date: fullDateStr }); 

  unBlockCourts({ courtNo: String(court), dates: [updated] })
    .then((res) => {
      if (res.status === 200) {
        getDisabledCourts().then((res) => {
          if (res.status === 200) {
            setDisableDate(res.data.data);
          }
        });
      }
    })
    .finally(() => {
      setLoadingCell({ court: null, date: null }); 
    });
};


  const handleMultiDateSelect = (court, datesArray) => {
    const formatted = datesArray.map((d) => formatDate(d));
    setPendingDates((prev) => ({ ...prev, [court]: formatted }));
  };

  const applyPendingDates = (court) => {
  const toAdd = pendingDates[court] || [];
  const convert = toAdd.map(convertToYMD);
  const alreadyDisabled = disabledDate[court]?.map((d) => d) || [];

  const newDates = convert.filter((date) => !alreadyDisabled.includes(date));

  if (newDates.length === 0) {
    toast.current.show({
  severity: "custom",
  life: 4000,
  content: (
    <div
      style={{
        backgroundColor: "#FF7F5077", 
        width: "100%",
        padding: "20px",
        display: "flex",
        justifyContent: "flex-start",
        gap: "12px",
        alignItems: "center",
        color: "white",
        borderRadius: "6px",
      }}
    >
      <GrClose size={20} className="text-white" />
      <span className="font-medium">
        Selected dates are already blocked for Court {court}.
      </span>
    </div>
  ),
});

    return;
  }

  const updated = { courtNo: String(court), dates: newDates };

  setLoading(true); 

  axios
    .post(postBlockedcourt, updated, {
      headers: { "Content-Type": "application/json",
      Authorization : `Encrypted ${encryptedAuth}` },
    })
    .then((res) => {
      if (res.status === 200) {
        toast.current.show({
  severity: "custom",
  life: 4000,
  content: (
    <div
      style={{
        backgroundColor: "#63F52066",
        width: "100%",
        padding: "20px",
        display: "flex",
        justifyContent: "flex-start",
        gap: "20px",
        alignItems: "center",
        color: "white",
        borderRadius: "6px",
      }}
    >
      <FaCheck size={24} />
      <span className="font-medium">
        Court {court} dates blocked successfully.
      </span>
    </div>
  ),
});

        getDisabledCourts().then((res) => {
          if (res.status === 200) {
            setDisableDate(res.data.data);
          }
        });
        setAppliedCourts((prev) => ({ ...prev, [court]: true }));
        setPendingDates((prev) => ({ ...prev, [court]: [] }));
      }
    })
    .catch(() => {
      toast.current.show({
  severity: "custom",
  life: 4000,
  content: (
    <div
      style={{
        backgroundColor: "#FF4D4D99",
        width: "100%",
        padding: "20px",
        display: "flex",
        justifyContent: "flex-start",
        gap: "12px",
        alignItems: "center",
        color: "white",
        borderRadius: "6px",
      }}
    >
      <GrClose  size={24} className="text-white" />
      <span className="font-medium">
        Failed to block dates for Court {court}.
      </span>
    </div>
  ),
});
    })
    .finally(() => {
      setLoading(false); 
    });
};


  const cancelPendingDates = (court) => {
    setPendingDates((prev) => ({ ...prev, [court]: [] }));
  };

  const slotData = courts.map((court, index) => ({
    id: index + 1,
    court,
    dates: pendingDates[court] || [],
  }));

  const dateTemplate = (rowData) => {
  const court = rowData.court;
  const selectedDates = (pendingDates[court] || []).map((d) => {
    const [day, monthStr, year] = d.split(" ");
    return new Date(`${day} ${monthStr} ${year}`);
  });

  let placeholder = "Choose Date";

  if (appliedCourts[court]) {
    placeholder = "Selected";
  } else if (selectedDates.length > 0) {
    placeholder = selectedDates
      .map((d) =>
        d.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
        })
      )
      .join(", ");
  }

  return (
    <Calendar
      selectionMode="multiple"
      value={selectedDates}
      onChange={(e) => handleMultiDateSelect(court, e.value || [])}
      placeholder={placeholder}
      dateFormat="dd-mm-yy"
       className={`md:w-[70%] ${appliedCourts[court] ? "selected-placeholder" : ""}`}
      minDate={new Date(new Date().setHours(0, 0, 0, 0))}
    />
  );
};


  const actionTemplate = (rowData) => {
    const court = rowData.court;
    const hasDates = pendingDates[court]?.length > 0;

    return hasDates ? (
      <div className="flex justify-center space-x-2">
        <button
          className="w-8 h-8 flex items-center justify-center bg-transparent text-red-500 border border-white rounded"
          onClick={() => cancelPendingDates(court)}
        >
          <X size={16} />
        </button>
        <button
          className="w-8 h-8 flex items-center justify-center bg-transparent text-green-500 border border-white rounded"
          onClick={() => applyPendingDates(court)}
        >
          <Check size={16} />
        </button>
      </div>
    ) : (
      <span className="text-gray-400">— —</span>
    );
  };

  return (
    <div className="bg-gradient-to-b from-[#0E1A2B] to-[#0E1A2B] text-white p-4 md:p-6 rounded-lg min-h-screen">
      <Toast ref={toast} />
      <div className="flex flex-wrap justify-between items-center mb-4 gap-4">
        <div className="relative inline-flex items-center bg-[#16243b] text-white px-4 py-2 rounded-full space-x-2">
  <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center">
    <CalendarIcon className="text-black" size={20} />
  </div>
  <span className="text-lg font-semibold">
    {selectedDate.toLocaleDateString("en-GB", { month: "long" })}
  </span>
  <Calendar
    value={selectedDate}
    onChange={(e) => {
      setSelectedDate(e.value);
      setStartIndex(0);
    }}
    dateFormat="dd/mm/yy"
    className=" absolute top-0 left-0 opacity-0 w-full h-full cursor-pointer "
    minDate={new Date(new Date().setHours(0, 0, 0, 0))}
  />
</div>


        <div className="flex flex-col md:flex-row gap-3 md:gap-6 items-center">
          <div className="flex items-center space-x-4">
            <div className="flex items-center space-x-2">
              <span className="w-3 h-3 rounded-full bg-[#003f66]" />
              <span className="text-xs text-white">Not available</span>
            </div>
            <div className="flex items-center space-x-2">
              <span className="w-3 h-3 rounded-full bg-[#00b3ff]" />
              <span className="text-xs text-white">Available</span>
            </div>
          </div>
          <div className="flex space-x-1">
            <button
              className="p-2 bg-transparent border-none text-white"
              onClick={() => setStartIndex((prev) => Math.max(0, prev - 7))}
            >
              <ChevronLeft size={30} />
            </button>
            <button
              className="p-2 bg-transparent border-none text-white"
              onClick={() => setStartIndex((prev) => prev + 7)}
            >
              <ChevronRight size={30} />
            </button>
          </div>
        </div>
      </div>

      <div className="overflow-x-auto border border-[#1f2d3a]">
        <div
          className="grid min-w-[600px] gap-[2px]"
          style={{ gridTemplateColumns: `100px repeat(${formattedDates.length}, 1fr) 50px` }}
        >
          {courts.map((court) => (
            <React.Fragment key={court}>
  <div className="relative col-span-full">
    {loadingCell === court && (
      <div className="absolute inset-0 bg-white bg-opacity-50 backdrop-blur-sm z-40 flex items-center justify-center">
        <ProgressSpinner style={{ width: '50px', height: '30px', color: 'black' }} strokeWidth="4" />
      </div>
    )}

    <div className="grid grid-cols-[100px_repeat(7,1fr)_50px] gap-[2px]">
      <div className="flex items-center justify-start px-2 h-8 text-xs font-medium">
        Court {court}
      </div>

      {fullDateStrings.map((dateStr) => (
<div
  key={`cell-${court}-${dateStr}`}
  className={`relative h-12 rounded-md transition-all flex items-center justify-center
    ${
      isAvailable(court - 1, dateStr)
        ? "bg-[#00b3ff] cursor-not-allowed"   
        : "bg-[#003f66] cursor-pointer hover:brightness-110" 
    }
    ${editingCourt === court ? "" : "opacity-90 cursor-not-allowed"}
  `}
  onClick={() => {
    if (!editingCourt === court) return; 
    const wasAvailable = isAvailable(court - 1, dateStr);
    if (!wasAvailable) {
      toggleAvailability(court, dateStr);

      toast.current?.show({
        severity: "custom",
        life: 4000,
        content: (
          <div
            style={{
              backgroundColor: "#4CAF5099",
              width: "100%",
              padding: "20px",
              display: "flex",
              justifyContent: "flex-start",
              gap: "12px",
              alignItems: "center",
              color: "white",
              borderRadius: "6px",
            }}
          >
            <Pencil size={20} className="text-white" />
            <span className="font-medium">
              Court {court} unblocked for {dateStr}
            </span>
          </div>
        ),
      });
    }
  }}
>
  {loadingCell.court === court && loadingCell.date === dateStr && (
    <ProgressSpinner style={{ width: "20px", height: "20px" }} strokeWidth="4" />
  )}
</div>




))}


<div className="flex items-center justify-center">
  <button
    className={`w-6 h-6 rounded-full flex items-center justify-center bg-transparent border-none ${
      editingCourt === court ? "text-yellow-500" : "text-white"
    }`}
    onClick={() => {
      const newValue = editingCourt === court ? null : court;
      setEditingCourt(newValue);

      if (newValue) {
        toast.current?.show({
          severity: "custom",
          life: 4000,
          content: (
            <div
              style={{
                backgroundColor: "#4CAF5099", 
                width: "100%",
                padding: "20px",
                display: "flex",
                justifyContent: "flex-start",
                gap: "12px",
                alignItems: "center",
                color: "white",
                borderRadius: "6px",
              }}
            >
              <Pencil size={20} className="text-white" />
              <span className="font-medium">
                Edit mode enabled for Court {court}.
              </span>
            </div>
          ),
        });
      } else {
        toast.current?.show({
          severity: "custom",
          life: 4000,
          content: (
            <div
              style={{
                backgroundColor: "#FF980099", 
                width: "100%",
                padding: "20px",
                display: "flex",
                justifyContent: "flex-start",
                gap: "12px",
                alignItems: "center",
                color: "white",
                borderRadius: "6px",
              }}
            >
              <GrClose size={20} className="text-white" />
              <span className="font-medium">
                Edit mode disabled for Court {court}.
              </span>
            </div>
          ),
        });
      }
    }}
  >
    <Pencil size={20} />
  </button>
</div>


    </div>
  </div>
</React.Fragment>
          ))}

          <div></div>
          {formattedDates.map((dateStr, idx) => (
            <div key={idx} className="text-center text-xs text-white pt-1 font-medium">
              {dateStr}
            </div>
          ))}
          <div></div>
        </div>
      </div>

      <div className="mt-20">
        <p className="font-bold mb-3 text-sm md:text-[30px]">SLOT MANAGEMENT</p>
        <div className="mt-10">
          <DataTable
            value={slotData}
            className="slot-table p-datatable-sm text-white "
            stripedRows
            responsiveLayout="scroll"
          >
            <Column field="id" header="S.No" body={(rowData) => `0${rowData.id}`} style={{ width: "80px" }} />
            <Column field="court" header="Court No" body={(rowData) => `Court ${rowData.court}`} />
            <Column header="Date" body={dateTemplate} headerStyle={{ paddingLeft:"12rem"}} />
            <Column header="Actions" body={actionTemplate} style={{ textAlign: "center", width: "120px" }} />
          </DataTable>
        </div>
      </div>
  
{loading && (
  <div className="fixed inset-0 bg-white bg-opacity-30 backdrop-blur-sm z-50 flex items-center justify-center">
    <ProgressSpinner style={{ width: '50px', height: '100px' }} strokeWidth="4" />
  </div>
)}

    </div>
  );
};

export default SlotManagement;